import React from "react";
import "./loginScreen.css";
import InteliIcon from "../../assets/image001.png";
import LoginCard from "../../components/LoginCard/LoginCard";

function LoginScreen() {
  return (
    <div className="authWrapper">
      {/* <div className="header">
        <img
          src={InteliIcon}
          width={122}
          height={"auto"}
          style={{ mixBlendMode: "darken" }}
        />
      </div> */}
      <div className="centerDiv">
        <LoginCard />
      </div>
    </div>
  );
}

export default LoginScreen;
